  export function getCurrencySymbol(code, locale) {
  const f = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
    currencyDisplay: 'narrowSymbol', // e.g. "£" instead of "GBP"
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  const parts = f.formatToParts(0);
  return parts.find(p => p.type === 'currency')?.value ?? code;
}

export function formatMinor(minor, code, locale) {
  const f = new Intl.NumberFormat(locale, { style: 'currency', currency: code });
  const { minimumFractionDigits } = f.resolvedOptions(); // currency default (0, 2, 3…)
  const major = minor / Math.pow(10, minimumFractionDigits);
  return f.format(major);
}